import React from "react";
import { Link } from "react-router-dom";
import { Calculator, Loader2, MessageCircle, Save, Scale, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import DkPdfSablonMenu from "./DkPdfSablonMenu";

export default function DkStickyBar({
    loading,
    pdfLoading,
    hesap,
    onizleme,
    seciliParcalar,
    rayic,
    kusur,
    seciliDosya,
    onHesapla,
    onPiyasaHesap,
    onKaydet,
    onPdf,
    onWhatsapp,
    onTahkimPaket,
}) {
    const net = onizleme?.tutar || hesap?.gercek_deger_kaybi_fmt;

    return (
        <div className="sticky bottom-0 z-30 -mx-6 px-4 py-3 border-t border-emerald-500/25 bg-[#060a12]/95 backdrop-blur-md">
            <div className="max-w-[100rem] mx-auto flex flex-wrap items-center justify-between gap-3">
                <div className="min-w-0">
                    <div className="text-[10px] uppercase tracking-wider text-slate-500">Canlı özet</div>
                    <div className="font-display text-xl text-emerald-300 tabular-nums">
                        {net || "—"}
                    </div>
                    <div className="text-[11px] text-slate-500 truncate">
                        Parça: {seciliParcalar.length}
                        {onizleme?.hasar_k != null ? (
                            <span className="text-amber-400/90">
                                {" "}
                                · Hasar kats. {(Number(onizleme.hasar_k) * 100).toFixed(0)}%
                            </span>
                        ) : null}
                        {rayic ? ` · Rayiç: ₺${Number(rayic).toLocaleString("tr-TR")}` : ""}
                        {kusur != null ? ` · Kusur: %${kusur}` : ""}
                        {hesap?.ogrenme_carpani && Math.abs(hesap.ogrenme_carpani - 1) > 0.001 ? (
                            <span className="text-violet-400">
                                {" "}
                                · Kalibrasyon ×{Number(hesap.ogrenme_carpani).toFixed(3)}
                            </span>
                        ) : null}
                    </div>
                </div>
                <div className="flex flex-wrap gap-2">
                    <Button
                        size="sm"
                        disabled={loading}
                        className="bg-emerald-600 hover:bg-emerald-500"
                        onClick={() => onHesapla(false)}
                    >
                        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Calculator className="h-4 w-4 mr-1" />}
                        Hesapla
                    </Button>
                    <Button size="sm" variant="outline" disabled={loading} onClick={() => onPiyasaHesap(true)}>
                        <Zap className="h-4 w-4 mr-1 text-[#D4AF37]" />
                        Piyasa+hesap
                    </Button>
                    {hesap ? (
                        <DkPdfSablonMenu
                            compact
                            disabled={loading}
                            loading={pdfLoading}
                            onIndir={onPdf}
                            hint={onPdf ? undefined : "Önce hesap yapın"}
                        />
                    ) : (
                        <DkPdfSablonMenu
                            compact
                            disabled
                            loading={pdfLoading}
                            hint="Önce hesap yapın"
                        />
                    )}
                    {seciliDosya && hesap ? (
                        <>
                            <Button size="sm" variant="outline" disabled={loading} onClick={onKaydet}>
                                <Save className="h-4 w-4 mr-1" />
                                Kaydet
                            </Button>
                            <Button size="sm" variant="outline" disabled={loading} onClick={onWhatsapp}>
                                <MessageCircle className="h-4 w-4 mr-1 text-green-400" />
                                WA
                            </Button>
                            <Button size="sm" variant="outline" disabled={loading} onClick={onTahkimPaket}>
                                <Scale className="h-4 w-4 mr-1 text-amber-400" />
                                Tahkim
                            </Button>
                        </>
                    ) : null}
                </div>
            </div>
            {hesap?.ogrenme_carpani ? (
                <div className="max-w-[100rem] mx-auto mt-1 text-[10px] text-slate-600">
                    <Link to="/yeni/dk-kalibrasyon" className="text-violet-400 hover:underline">
                        Kalibrasyon merkezi →
                    </Link>
                </div>
            ) : null}
        </div>
    );
}
